import { render, staticRenderFns } from "./addScore.vue?vue&type=template&id=91fd2a2c&scoped=true"
import script from "./addScore.vue?vue&type=script&lang=js"
export * from "./addScore.vue?vue&type=script&lang=js"
import style0 from "./addScore.vue?vue&type=style&index=0&id=91fd2a2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fd2a2c",
  null
  
)

export default component.exports